import { Backdrop, CssBaseline } from "@mui/material";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Toolbar from "@mui/material/Toolbar";
import { navigate } from "@reach/router";
import axios from "axios";
import { onAuthStateChanged } from "firebase/auth";
import PropTypes from "prop-types";
import React from "react";
import { useDispatch } from "react-redux";
import CustomLoader from "../component/loader";
import { auth } from "../config/firebase";
import { getNotification, getUserInfo, toCoinAmount } from "../config/services";
import AppbarMain from "./appbar/appbar";
import DrawerMenu from "./appbar/drawer";
import { userinfo$, walletData$ } from "./redux/action";
import { Helmet } from "react-helmet";

const drawerWidth = 300;

function ResponsiveDrawer(props) {
  const { window } = props;
  const [loading, setLoading] = React.useState(false);
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const dispatch = useDispatch();
  let totalbalance = [];

  React.useEffect(() => {
    setLoading(true);
    onAuthStateChanged(auth, (user) => {
      if (user) {
        //get notifications
        getNotification(user.uid);
        //get user infos
        getUserInfo(user.uid).subscribe((userData) => {
          const {
            btc_balance,
            bnb_balance,
            tron_balance,
            eth_balance,
            usdt_balance,
            usdterc20_balance,
          } = userData;

          //totalbalance
          totalbalance = [
            btc_balance,
            bnb_balance,
            tron_balance,
            eth_balance,
            usdt_balance,
            usdterc20_balance,
          ].reduce((prv, cur) => {
            return prv + cur;
          }, 0);

          dispatch(
            userinfo$({ ...userData, id: user.uid, totalBalance: totalbalance })
          );

          //get crypto info
          axios
            .get(
              "https://api.coingecko.com/api/v3/simple/price?ids=bitcoin%2Cethereum%2Cbinancecoin%2Ctron%2Ctether%2C&vs_currencies=usd&include_24hr_change=true"
            )
            .then((res) => {
              const prices = res.data;

              dispatch(
                walletData$([
                  {
                    coinname: "BITCOIN",
                    cointype: "btc_balance",
                    price: prices.bitcoin.usd,
                    difference: prices.bitcoin.usd_24h_change,
                    balance: btc_balance,
                    balancecoin: toCoinAmount(btc_balance, prices.bitcoin.usd),
                    code: "BTC",
                    image: "./images/coins/btc.png",
                    address: "bc1qvcny9273tekt7cg85k9kt2g5k0dhpwdrjp356x",
                    network: "BTC",
                  },
                  {
                    coinname: "ETHEREUM",
                    cointype: "eth_balance",
                    price: prices.ethereum.usd,
                    difference: prices.ethereum.usd_24h_change,
                    balance: eth_balance,
                    balancecoin: toCoinAmount(eth_balance, prices.ethereum.usd),
                    code: "ETH",
                    image: "./images/coins/eth.png",
                    address: "0x2F39B4eC094DF801837b338211933E2d425fb332",
                    network: "Ethereum",
                  },
                  {
                    coinname: "BNB SMART",
                    cointype: "bnb_balance",
                    price: prices.binancecoin.usd,
                    difference: prices.binancecoin.usd_24h_change,
                    balance: bnb_balance,
                    balancecoin: toCoinAmount(
                      bnb_balance,
                      prices.binancecoin.usd
                    ),
                    code: "BNB",
                    image: "./images/coins/bnb.png",
                    address: "bnb13m39rjwfj7kjpeh627d8hmfx2k9xgwckvm2lmn",
                    network: "Bep20",
                  },
                  {
                    coinname: "TRON",
                    cointype: "tron_balance",
                    price: prices.tron.usd,
                    difference: prices.tron.usd_24h_change,
                    balance: tron_balance,
                    balancecoin: toCoinAmount(tron_balance, prices.tron.usd),
                    code: "TRX",
                    image: "./images/coins/tron.png",
                    address: "TZ9YZp1CjnL5o4YFifhWGwE6DdVAvmebJg",
                    network: "Tron",
                  },
                  {
                    coinname: "USDT(TRC20)",
                    cointype: "usdt_balance",
                    price: prices.tether.usd,
                    difference: prices.tether.usd_24h_change,
                    balance: usdt_balance,
                    balancecoin: toCoinAmount(usdt_balance, prices.tether.usd),
                    code: "USDT TRC20",
                    image: "./images/coins/usdt.png",
                    address: "TZ9YZp1CjnL5o4YFifhWGwE6DdVAvmebJg",
                    network: "Tron",
                  },
                  {
                    coinname: "USDT(ERC20)",
                    cointype: "usdterc20_balance",
                    price: prices.tether.usd,
                    difference: prices.tether.usd_24h_change,
                    balance: usdterc20_balance,
                    balancecoin: toCoinAmount(
                      usdterc20_balance,
                      prices.tether.usd
                    ),
                    code: "USDT ERC20",
                    image: "./images/coins/usdt.png",
                    address: "0x2F39B4eC094DF801837b338211933E2d425fb332",
                    network: "Ethereum",
                  },
                ])
              );
              setLoading(false);
            })
            .catch((error) => console.log(error));
        });
      } else {
        navigate("./account/login");
      }
    });
  }, []);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = <DrawerMenu action={handleDrawerToggle} />;

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <React.Fragment>
      <Helmet>
        <script src="//code.jivosite.com/widget/bKChuPwXvo" async />
      </Helmet>
      <CssBaseline />
      <Box
        sx={{
          display: {
            sm: "block",
            md: "flex",
          },
        }}
      >
        <AppbarMain handleDrawer={handleDrawerToggle} />
        <Box
          component="nav"
          sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
          aria-label="mailbox folders"
        >
          {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,

                // backgroundColor: "#4a21ef",
              },
            }}
          >
            {drawer}
          </Drawer>

          <Drawer
            variant="permanent"
            sx={{
              display: { xs: "none", sm: "block" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
                // backgroundColor: "#4a21ef",
              },
            }}
            open
          >
            {drawer}
          </Drawer>
        </Box>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            pt: 2,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
          }}
        >
          <Toolbar />

          {props.children}
        </Box>
      </Box>
      <Backdrop
        sx={{
          backgroundColor: "#ffffffcf",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={loading}
      >
        <CustomLoader />
      </Backdrop>
    </React.Fragment>
  );
}

ResponsiveDrawer.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default ResponsiveDrawer;
